// Calcula la completitud de las postulaciones sin calcular y de las que
// cambiaron desde la última corrida. Es la misma corrida que el timer del
// cyber-service ejecuta cada 5 minutos; este botón solo la adelanta.
//
//   POST {APPLICANT}/application/refresh-completeness?userId=<id>
//   → { message, run }
//   GET  {APPLICANT}/application/completeness-status?userId=<id>
//   → { runs, running }   (las últimas corridas, la más reciente primero, y si
//                          hay una en curso ahora: timer, otro usuario o este)
//
// Solo el perfil adm_ti ve el botón; el backend vuelve a validar el perfil.

import { readApiErrorMessage } from "../components/pages/Postulaciones/postulacionesUtils";

export interface ICalculoCompletitudCorrida {
  id: string;
  origin: "TIMER" | "MANUAL";
  status: "EN_CURSO" | "COMPLETADA" | "PARCIAL" | "ERROR" | "INTERRUMPIDA";
  sinceDate: string;
  created: number;
  changed: number;
  updated: number;
  message: string | null;
  startedAt: string;
  finishedAt: string | null;
}

export interface ICalcularCompletitudResult {
  message: string;
  run?: ICalculoCompletitudCorrida;
}

const buildUrl = (resource: string): string => {
  const userId = sessionStorage.getItem("usuarioId") ?? "";
  const baseUrl = process.env.REACT_APP_API_APPLICANT;
  if (!baseUrl) throw new Error("Configuración faltante: REACT_APP_API_APPLICANT.");
  return `${baseUrl}/application/${resource}?userId=${encodeURIComponent(userId)}`;
};

export const calcularCompletitud = async (): Promise<ICalcularCompletitudResult> => {
  const res = await fetch(buildUrl("refresh-completeness"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });

  if (!res.ok) {
    throw new Error(await readApiErrorMessage(res));
  }

  return (await res.json()) as ICalcularCompletitudResult;
};

export interface IEstadoCalculoCompletitud {
  runs: ICalculoCompletitudCorrida[];
  /** Hay una corrida en curso (solo puede haber una a la vez). */
  running: boolean;
}

export const getEstadoCalculoCompletitud = async (): Promise<IEstadoCalculoCompletitud> => {
  const res = await fetch(buildUrl("completeness-status"));

  if (!res.ok) {
    throw new Error(await readApiErrorMessage(res));
  }

  const body = (await res.json()) as { runs?: ICalculoCompletitudCorrida[]; running?: boolean };
  const runs = body.runs ?? [];
  // Backend sin `running` (versión anterior): se infiere de la última corrida.
  return { runs, running: body.running ?? runs[0]?.status === "EN_CURSO" };
};
